import { motion } from "framer-motion";
import { Heart, HandHeart, Home } from "lucide-react";
import { useLanguage, translations } from "../context/LanguageContext";

const ProgramsPage = () => {
  const { language } = useLanguage();
  const t = translations[language].programs;

  return (
    <div>
      {/* Hero */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{ backgroundImage: `url('https://images.unsplash.com/photo-1760633549227-901e0c3cf9d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxIaXNwYW5pYyUyMExhdGlubyUyMGZhbWlseSUyMGNoaWxkcmVuJTIwaGFwcHklMjBob21lfGVufDB8fHx8MTc3NTY4NDIwMXww&ixlib=rb-4.1.0&q=85')` }} />
        <div className="relative max-w-7xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-warm-700 mb-4 block">{t.heroOverline}</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-tight text-gray-900 mb-6"
              style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }} data-testid="programs-hero-title">{t.heroTitle}</h1>
            <p className="text-lg md:text-xl leading-relaxed text-gray-600">{t.heroSubtitle}</p>
          </motion.div>
        </div>
      </section>

      {/* Violence Intervention Services */}
      <section className="py-20 md:py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-warm-700 mb-4 block">{t.servicesOverline}</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-snug text-gray-900 mb-4" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>{t.servicesTitle}</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t.servicesSubtitle}</p>
          </motion.div>
          <div className="grid md:grid-cols-3 gap-8">
            {t.services.map((service, idx) => {
              const icons = [Heart, HandHeart, Home];
              const ServiceIcon = icons[idx];
              return (
                <motion.div key={service.title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: idx * 0.1 }}
                  className="bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-md transition-all">
                  <div className="w-14 h-14 bg-warm-100 rounded-2xl flex items-center justify-center mb-6"><ServiceIcon className="w-7 h-7 text-warm-700" /></div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Future Vision */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-warm-700 mb-4 block">{t.futureOverline}</span>
            <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-snug text-gray-900 mb-6" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>{t.futureTitle}</h2>
            <p className="text-gray-600 leading-relaxed mb-8">{t.futureDescription}</p>
            <p className="text-sm text-gray-500">{t.futureNote}</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ProgramsPage;
